import api from './api';

const BASE = '/api/land-units';

// ── Land units ──────────────────────────────────────────────────────────────
export const getLandUnits    = (params)      => api.get(BASE, { params });
export const getLandUnit     = (id)          => api.get(`${BASE}/${id}`);
export const createLandUnit  = (data)        => api.post(BASE, data);
export const updateLandUnit  = (id, data)    => api.put(`${BASE}/${id}`, data);
export const deleteLandUnit  = (id)          => api.delete(`${BASE}/${id}`);

// ── Factor observations ─────────────────────────────────────────────────────
export const getFactorObservations   = (unitId, params) => api.get(`${BASE}/${unitId}/factors`, { params });
export const addFactorObservation    = (unitId, data)   => api.post(`${BASE}/${unitId}/factors`, data);
export const updateFactorObservation = (unitId, obsId, data) => api.put(`${BASE}/${unitId}/factors/${obsId}`, data);
export const deleteFactorObservation = (unitId, obsId) => api.delete(`${BASE}/${unitId}/factors/${obsId}`);
export const getFactorSummary       = (unitId, params) => api.get(`${BASE}/${unitId}/factor-summary`, { params });
export const getScoreSnapshot       = (unitId, params) => api.get(`${BASE}/${unitId}/score-snapshot`, { params });

// ── Staff evaluation notes ───────────────────────────────────────────────────
export const getNotes = (unitId)       => api.get(`${BASE}/${unitId}/notes`);
export const addNote  = (unitId, data) => api.post(`${BASE}/${unitId}/notes`, data);

// ── Review workflow ──────────────────────────────────────────────────────────
export const getReviewHistory = (unitId)       => api.get(`${BASE}/${unitId}/review`);
export const setReviewStatus  = (unitId, data) => api.post(`${BASE}/${unitId}/review`, data);

// ── Staff evaluations / recommendations ─────────────────────────────────────
export const getEvaluations = (unitId)       => api.get(`${BASE}/${unitId}/evaluations`);
export const addEvaluation  = (unitId, data) => api.post(`${BASE}/${unitId}/evaluations`, data);
// ── Unit report ─────────────────────────────────────────────────────
export const getUnitReport = (unitId) => api.get(`${BASE}/${unitId}/report`);
// ── Staff platform overview ─────────────────────────────────────────────────
export const getPlatformSummary = (params) => api.get(`${BASE}/platform-summary`, { params });
